import { render } from "./LoginForm.vue?vue&type=template&id=db7bf650"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=db7bf650&lang=css"

import exportComponent from "/Users/nori/Dropbox (Nakajima Glass)/ngciio/ngci-members/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__